import { API_BASE_URL } from '../../../lib/api';
import { withTenant } from '@/lib/tenantHeaders';
import { apiFetch } from '@/lib/apiFetch';

/**
 * Invitaciones a proveedores para solicitudes LCL.
 *
 * Comparte el endpoint con el aéreo: el backend decide la rama por el
 * id que llegue (`lclRequestId` en vez de `airRequestId`).
 *
 * Los headers se construyen dentro de cada función (ver nota en
 * `lclRequestsService.js`).
 */
const jsonHeaders = () => withTenant({ 'Content-Type': 'application/json' });

/**
 * Envía invitaciones de cotización a N proveedores.
 * @param {string} lclRequestId
 * @param {string[]} providerIds
 * @param {string} replyTo - email del usuario logueado (Reply-To)
 * @param {string} [notes]
 */
export async function sendLclProviderInvitations({
  lclRequestId,
  providerIds,
  replyTo,
  notes,
}) {
  const res = await apiFetch(`${API_BASE_URL}/provider-invitations/send`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ lclRequestId, providerIds, replyTo, notes }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.message || 'No se pudieron enviar las invitaciones');
  }
  return res.json();
}

/** Lista las invitaciones de una solicitud LCL. */
export async function fetchInvitationsByLclRequest(lclRequestId) {
  const res = await apiFetch(
    `${API_BASE_URL}/provider-invitations/lcl-request/${lclRequestId}`,
    { headers: withTenant() },
  );
  if (!res.ok) throw new Error('No se pudieron cargar las invitaciones');
  return res.json();
}
